module.exports = __webpack_public_path__ + "static/media/bQ.8e8aadb6.svg";